<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Welcome back!
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-4xl">Refinance Your Loan</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-refresh text-primary text-5xl"/>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">
            <template #text>
                <div class="mb-4">
                    <p class="text-gray-600 mb-1">Current Loan Amount</p>
                    <p class="font-medium text-gray-900 text-lg">{{ loan.amount | money(0) }}</p>
                </div>

                <div class="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                    <p class="text-blue-800 text-sm">
                        <i class="fa fa-info-circle mr-2"></i>
                        Refinancing allows you to get additional funds while your current loan is still active.
                        Your remaining balance will be incorporated into the new loan.
                    </p>
                </div>

                <ReApplyButton
                    :loan="loan"
                    button-text="Apply for Refinance"
                    :redirect-after-success="true"
                />
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
import ReApplyButton from '../../../components/ReApplyButton.vue';

export default {
    mixins: [require('../../../mixins/InteractsWithGtag').default],

    components: {
        ReApplyButton
    },

    props: ['loan'],

    data() {
        return {
            gTagPageName: 'introxl-refi',
        }
    },

    created() {
        this.gTagEvent('introxl-refi', {
            event_category: 'onboarding',
            event_label: 'introxl-refi',
        });
    },
}
</script>
